<template>
  <v-col class='pa-5'>
    <h2> {{$translate('STORE_CREDIT')}} </h2>
    <v-card class="pa-4 mb-4" outlined v-for="(credit, index) in credits" :key="index">
      {{$translate('YOUR_STORE_CREDIT')}}
      <strong>{{credit.Name}}</strong>
      {{$translate('CONTAINS')}}
      <strong>{{formatter.format(credit.UserCredit)}}</strong>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UserSettingsCredits',
  components: {
  },
  computed: {
    ...mapGetters({
      credits: 'auth/userCredits',
    }),
  },
  data() {
    return {
      formatter: new Intl.NumberFormat(
        'nl',
        { style: 'currency', currency: 'EUR' },
      ),
    };
  },
};
</script>
